/* eslint-disable @typescript-eslint/prefer-optional-chain */
import React, { useState } from 'react';
import { Grid, InputLabel, FormControl, Autocomplete, TextField, Box } from '@mui/material';
import { Controller } from 'react-hook-form';

interface CountryType {
  name: string;
  dial_code: string;
  code: string;
}

interface Props {
  countryCodeArray: CountryType[];
  data?: any;
  control: any;
  errors: any;
  onChange: (value: CountryType | null) => void;
  name: string;
  showMark: boolean;
  required?: boolean;
  // Optional dark-mode styling for the country-code dropdown paper. The dropdown
  // renders in a portal, so callers inside a dark surface pass their dark paper
  // sx here; omitted elsewhere, the dropdown keeps its default (light) look.
  paperSx?: object;
}

const PhoneInput: React.FC<Props> = ({ countryCodeArray, data, control, errors, onChange, name, showMark, required, paperSx }) => {
  // const selectedCountryObject = countryCodeArray.find(
  //   (country) => country.dial_code === data.phonePrefix
  // );

  const selectedCountryObject =
    data && data.phonePrefix ? countryCodeArray.find((country) => country.dial_code === data.phonePrefix) : null;

  const [selectedCountry, setSelectedCountry] = useState<CountryType | null>(selectedCountryObject || null);

  const handleCountryChange = (event: React.ChangeEvent<{}>, value: CountryType | null, inputValue: string) => {
    if (value) {
      setSelectedCountry(value);
      onChange(value); // Call the onChange function from the Controller component
    } else {
      // Find the country based on the input value (prefix code)
      const country = countryCodeArray.find((country) => country.dial_code === inputValue);
      setSelectedCountry(country || null);
      onChange(country || null); // Call the onChange function from the Controller component
    }
  };

  const getOptionLabel = (option: CountryType | null) => {
    if (option) {
      return `${option.dial_code}`;
    }
    return '';
  };

  return (
    <>
    <InputLabel>Phone number {required && '*'}</InputLabel>
      <Grid container>
        <Grid item xs={6}>
          <FormControl fullWidth>
            <Autocomplete
              id="phoneNumber-Prefix"
              size="small"
              // sx={{ width: 300 }}
              componentsProps={paperSx ? { paper: { sx: paperSx } } : undefined}
              options={countryCodeArray}
              autoHighlight
              getOptionLabel={getOptionLabel}
              renderOption={(props, option) => (
                <Box component="li" sx={{ '& > img': { mr: 2, flexShrink: 0 } }} {...props}>
                  <Box
                    component={'img'}
                    loading="lazy"
                    width="20px"
                    src={`https://flagcdn.com/w20/${option.code.toLowerCase()}.png`}
                    srcSet={`https://flagcdn.com/w40/${option.code.toLowerCase()}.png 2x`}
                    alt="flagIcon"
                  />
                  {option.dial_code}
                </Box>
              )}
              renderInput={(params) => (
                <TextField
                  sx={{
                    '& .MuiOutlinedInput-root': {
                      borderRadius: ' 8px 0 0 8px !important',
                      paddingRight:'16px !important'
                    }
                  }}
                  variant="outlined"
                  // style={{ width: "100px" }}
                  {...params}
                  placeholder="+91"
                  inputProps={{
                    ...params.inputProps,
                    // autoComplete: 'phonePrefix'
                    autoComplete: 'off'
                  }}
                  // helperText={
                  //   !selectedCountry && "Phone Prefix is required"
                  // }
                  // FormHelperTextProps={{
                  //   style: { color: 'red' }
                  // }}
                  InputProps={{
                    ...params.InputProps,
                    startAdornment: selectedCountry && (
                      <Box
                        component={'img'}
                        ml={'5px'}
                        loading="lazy"
                        width="20px"
                        src={`https://flagcdn.com/w20/${selectedCountry.code.toLowerCase()}.png`}
                        srcSet={`https://flagcdn.com/w40/${selectedCountry.code.toLowerCase()}.png 2x`}
                        alt="flagIcon"
                      />
                    )
                  }}
                />
              )}
              // onChange={handleCountryChange}
              onInputChange={(event, newInputValue) => {
                handleCountryChange(event, null, newInputValue);
              }}
              value={selectedCountry}
              clearOnBlur={false}
            />
          </FormControl>
        </Grid>

        <Grid item xs={6}>
          <Controller
            name={name}
            control={control}
            render={({ field: { onChange, value } }) => (
              <TextField
                sx={{
                  '& .MuiOutlinedInput-root': {
                    borderRadius: '0 8px 8px 0px !important'
                  }
                }}
                size="small"
                // required
                name={name}
                value={value || ''}
                id="phoneNumber"
                type="text"
                placeholder="1234567890"
                variant="outlined"
                onChange={onChange}
                error={Boolean(errors[name])}
                helperText={errors[name] ? String(errors[name].message) : ''}
                inputProps={{
                  maxLength: 15
                }}
                FormHelperTextProps={{
                  style: { color: 'red' }
                }}
              />
            )}
          />
        </Grid>
      </Grid>
    </>
  );
};

export default PhoneInput;
